import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EUserCardActionTypes {
  Open = 'UserCard/open',
  Close = 'UserCard/close',
}

export type TUserCardActions =
  | ITypedReduxAction<EUserCardActionTypes.Open, void>
  | ITypedReduxAction<EUserCardActionTypes.Close, void>;
